const { getNumber } = require('../utils');
export default [
    {
        title: '账户',
        type: 'string',
        dataIndex: 'name',
        key: 'name',
        width: '12%',
        sorter: (a, b) => Number(a.name) - Number(b.name),
        defaultSortOrder: 'ascend',
        // editable: true,
    },
    {
        title: '密码',
        type: 'string',
        dataIndex: 'password',
        key: 'password',
        width: '15%',
        editable: true,
    },
    {
        title: '历史记录',
        type: 'array',
        dataIndex: 'history',
        key: 'history',
        render: (text) => JSON.stringify(text),
        width: '50%',
        editable: true,
    }
];